import { Repository } from "src/firebase/firestore/repository";
import { SlotRequest } from "./types/slot-request.entity";

class SlotRequestRepository extends Repository<SlotRequest> {
  constructor() {
    super("slot_requests");
  }
}

export const slotRequestRepository = new SlotRequestRepository();
